export const measureColors: { [key: string]: string } = {
    ppt: '#c0c0ff',
    ws: '#aaaaaa',
    tmax: '#e84749',
    tmin: '#2828aa',
    sst: '#66bbdd',
    wet: '#559966',
    sunhrs: '#eec822',
    rhm: '#bb8822',
}